<template>
  <span class="main-span">
    <svg class="upper-svg" width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 5L5.00621 2.58009e-07L10 5L0 5Z" :fill="sortDirection === 'ASC' ? '#1A73E8' : '#C3CAD4'" />
    </svg>
    <svg class="lower-svg" width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 5L5.00621 2.58009e-07L10 5L0 5Z" :fill="sortDirection === 'DESC' ? '#1A73E8' : '#C3CAD4'" />
    </svg>
  </span>
</template>
<script>
export default {
  props: {
    sortDirection: {
      type: String,
      default: 'ASC'
    }
  }
}
</script>
<style>
.main-span {
  display: flex;
  flex-direction: column;
}

.upper-svg {
  margin: 2px;
}

.lower-svg {
  transform: rotate(180deg);
  margin: 2px;
}</style>
